import SearchRobot from './SearchRobot'
export default SearchRobot
